import { addAlpha } from "@/helpers/utils.js";

const commonStyles = {
  props: {
    styling: {
      type: Object,
    },
    editing: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      required: true,
    },
    isChildComponent: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // Item Level Styles
    itemStyling() {
      return this.item.styling || {};
    },
    // Input Styles
    inputStyles() {
      return {
        "background-color": this.isDisabled
          ? addAlpha(this.styling.placeholderColor, 0.9)
          : this.styling.placeholderColor,
        "font-family": this.styling.fontFamily || "sans-serif",
        cursor: this.isDisabled ? "not-allowed" : "auto",
        opacity: this.isDisabled ? 0.6 : 1,
      };
    },
    // Layout Classes
    layoutClasses() {
      return {
        "left-right": this.styling.alignment === "Left-Right",
      };
    },
    // Root Classes
    rootClasses() {
      return {
        active: this.active,
        "drag-wrapper": this.editing,
        "non-editing": !this.editing,
      };
    },
    // Root Styles
    rootStyles() {
      if (this.isChildComponent) return {};

      return {
        "margin-top": this.styling.marginTop
          ? `${this.styling.marginTop}px`
          : "",
        "margin-bottom": this.styling.marginBottom
          ? `${this.styling.marginBottom}px`
          : "",
      };
    },
    // Label Styles
    labelStyles() {
      return {
        // default styles
        display: "block",

        // custom styles
        "margin-bottom": this.styling.labelBottomMargin
          ? `${this.styling.labelBottomMargin}px`
          : "8px",
        color: this.styling.fontColor || "#575757",
        "font-family": this.styling.fontFamily || "sans-serif",
        "font-size": this.item.componentFromRepeatField
          ? `${this.styling.optionFontSize}px`
          : `${this.styling.fontSize}px` || "16px",
        "font-weight": this.item.componentFromRepeatField
          ? this.styling.optionFontWeight
          : this.styling.labelFontWeight || 700,
        "font-style": this.styling.italicFont ? "italic" : "normal",
        "line-height": "150%",
        margin: !this.item.label && "0px",
        "word-wrap": "break-word",
      };
    },
    // Description Styles
    descriptionStyles() {
      return {
        color: this.styling.descriptionFontColor || "#3D3D3DB3",
        "font-family": this.styling.fontFamily || "sans-serif",
        "font-size": `${this.styling.descriptionFontSize}px` || "14px",
        "font-style": this.styling.italicFont ? "italic" : "normal",
        "font-weight": this.styling.descriptionFontWeight || 400,
        "line-height": "150%",
        "margin-bottom": this.styling.descriptionBottomMargin
          ? `${this.styling.descriptionBottomMargin}px`
          : "8px",
        margin: !this.item.description && !this.editing && "0px",
        "word-wrap": "break-word",
      };
    },
    // SubLabel Styles
    subLabelStyles() {
      return {
        // default styles
        display: "block",
        "margin-bottom": "8px",

        // custom styles
        color: this.styling.fontColor || "#575757",
        "font-family": this.styling.fontFamily || "sans-serif",
        "font-size": `${this.styling.sublabelFontSize}px` || "12px",
        "font-weight": this.styling.sublabelFontWeight || 400,
        "line-height": "150%",
      };
    },
    // Option Styles
    optionStyles() {
      return {
        color: this.styling.optionFontColor,
        "font-style": this.styling.italicFont ? "italic" : "normal",
        "font-family": this.styling.fontFamily || "sans-serif",
        "font-size": `${this.styling.optionFontSize}px` || "12px",
        "font-weight": this.styling.optionFontWeight || 400,
        "line-height": "150%",
      };
    },
    // Label Classes
    labelClasses() {
      return {
        "formester-label": true,
        "field-required formester-required":
          this.item.required && this.styling.isRequiredMarkerVisible, // TODO: rename the class to something better
      };
    },
    labelDescriptionWrapperStyles() {
      return {
        paddingBottom:
          this.item.description || (this.editing && this.active)
            ? "8px"
            : "12px",
      };
    },
  },
  methods: {
    // SubLabel Classes
    subLabelClasses(required) {
      return {
        "formester-label": true,
        "field-required formester-required":
          required && this.styling.isRequiredMarkerVisible, // TODO: rename the class to something better
      };
    },
  },
};

export default commonStyles;
